import Reveal from '@/components/feature/Reveal';
import { SectionWrapper, SectionHeading } from '@/components/feature/SectionHeading';
import FAQAccordion from '@/components/feature/FAQAccordion';
import CTASection from '@/components/feature/CTASection';
import AsaHero from '@/pages/services/ai-security/components/AsaHero';
import BulletSection from '@/pages/services/ai-security/components/BulletSection';
import ProcessSection from '@/pages/services/ai-security/components/ProcessSection';
import { asaHero, asaBlocks, asaFaq, asaCta } from '@/pages/services/ai-security/content';

export default function AiSecurityPage() {
  const contactTo = `/contact/?service=${encodeURIComponent(asaHero.serviceKey)}`;

  return (
    <>
      <AsaHero
        tag={asaHero.tag}
        title={asaHero.title}
        subtitle={asaHero.subtitle}
        description={asaHero.description}
        buttonText={asaHero.buttonText}
        to={contactTo}
      />

      {asaBlocks.map((block) =>
        block.type === 'process' ? (
          <ProcessSection key="process" eyebrow={block.eyebrow} title={block.title} steps={block.steps} />
        ) : (
          <BulletSection key={block.id} section={block} />
        )
      )}

      <SectionWrapper className="bg-[#12121f]">
        <SectionHeading eyebrow="FAQ" title="よくあるご質問" />
        <Reveal className="mt-12 md:mt-16 max-w-3xl mx-auto">
          <FAQAccordion items={asaFaq} />
        </Reveal>
      </SectionWrapper>

      <CTASection
        title={asaCta.title}
        description={asaCta.description}
        buttonText={asaCta.buttonText}
        to={contactTo}
      />
    </>
  );
}